// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { IProps, ITabsProps, Tab, Tabs } from "@blueprintjs/core";

import "./styles.css";

export interface ISettingsTabsProps extends IProps {
  tabs: Array<string>;
  tabsProps?: ITabsProps;
}

export const SettingsTabs: React.SFC<ISettingsTabsProps> = props => {
    const { className, tabs, tabsProps } = props;
    const classes = classNames('settings-tabs', className);
    return (
      <Tabs id='settings-tabs' className={classes} {...tabsProps}>
        {tabs.map((title: any, index:number) => (
            <Tab id={index} title={title} key={index} />
        ))}
      </Tabs>
    );
}

export default SettingsTabs;



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/components/settings-tabs/settings-tabs.tsx